import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import parse from 'html-react-parser'
import { getStudentIdData, getStudentIdDataWithStatus } from '../../../lib/taskmanageview'
import StudentInfoBox from '../studentinfo/studentinfobox'
import StudentTopMenu from '../studentinfo/studenttopmenu'
import PageNotes from '../../pages/common/pagenotesnew'

export default function ParentStudentTaskList() {
	const [tasklist, setTasklist] = useState([])
	// 1 : All , 2 : Current ,3:Later  4 : Closed
	const [tab, setTab] = useState(1)
	const [collapseOpenClose, setCollapseOpenClose] = useState(false)

	const toggleTab = (id) => {
		setTab(id)
	}

	let { slug } = useParams()

	async function GetData() {
		let tasks
		switch (tab) {
			case 1: // All
				tasks = await getStudentIdData(slug)
				break
			case 2: // Current
				tasks = await getStudentIdDataWithStatus(slug, 'Current')
				break
			case 3: // Later
				tasks = await getStudentIdDataWithStatus(slug, 'Later')
				break
			case 4: // Closed
				tasks = await getStudentIdDataWithStatus(slug, 'Closed')
				break
			default:
				tasks = await getStudentIdData(slug)
		}

		setTasklist(tasks || [])
	}

	useEffect(() => {
		GetData()
	}, [tab, slug])

	useEffect(() => {
		setTab(1)
	}, [])

	return (
		<>
			{/* <STopMenu slug={slug} activeMenu="Task" /> */}
			<StudentInfoBox slug={slug} />
			<StudentTopMenu slug={slug} activeMenu={'Agenda'} />
			<PageNotes type={'Student'} studentId={slug} />
			<div className="col-12">
				<div className="settings-widget profile-details">
					<div className="settings-inner-blk p-0">
						<div className="profile-heading">
							<h3>Agenda</h3>
						</div>
						<div className="comman-space pb-0">
							<div className="category-tab tickets-tab-blk">
								<div className="row mb-4 align-items-center h-100">
									<div className="col text-end">
										<br />
										<br />
										<ul className="nav nav-justified ">
											<li></li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#all"
													className={tab === 1 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(1)
													}}
												>
													All
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#open"
													className={tab === 2 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(2)
													}}
												>
													Agenda-1
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#open"
													className={tab === 3 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(3)
													}}
												>
													Agenda-2
												</Link>
											</li>
											<li className="nav-item" style={{ flexBasis: 'auto' }}>
												<Link
													//to="#close"
													className={tab === 4 ? 'nav-link active' : 'nav-link'}
													//data-bs-toggle="tab"
													onClick={(e) => {
														e.preventDefault()
														toggleTab(4)
													}}
												>
													Closed
												</Link>
											</li>
										</ul>
									</div>
									<div className="col text-end">
										<button
											className="btn btn-outline-info"
											onClick={() => {
												if (collapseOpenClose) {
													setCollapseOpenClose(false)
												} else {
													setCollapseOpenClose(true)
												}
											}}
										>
											{collapseOpenClose ? (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="18"
														height="18"
														fill="currentColor"
														className="bi bi-chevron-double-up me-1"
														viewBox="0 0 16 16"
													>
														<path
															fillRule="evenodd"
															d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
														<path
															fillRule="evenodd"
															d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
													</svg>{' '}
													Collapse All
												</>
											) : (
												<>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="18"
														height="18"
														fill="currentColor"
														className="bi bi-chevron-double-down me-1"
														viewBox="0 0 16 16"
													>
														<path
															fillRule="evenodd"
															d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
														<path
															fillRule="evenodd"
															d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
														/>
													</svg>{' '}
													Expand All
												</>
											)}
										</button>
									</div>
								</div>
							</div>
							<div className="settings-invoice-blk table-responsive">
								{/* Invoice info */}
								<table className="table table-hover">
									<thead>
										<tr>
											<th>Instructor</th>
											<th>Topic</th>
											<th>Status</th>
											<th>Detail</th>
										</tr>
									</thead>
									<tbody>
										{tasklist.map(function (data, ix) {
											return (
												<React.Fragment key={data.id}>
													<tr>
														<td>{data.instructorinfo}</td>
														<td>{data.subject}</td>
														<td>
															{' '}
															{data.statusway === 'Current' ? (
																<span className="badge info-low"> Agenda-1</span>
															) : data.statusway === 'Later' ? (
																<span className="badge badge-warning">Agenda-2</span>
															) : data.statusway === 'Closed' ? (
																<span className="badge info-high">Closed</span>
															) : (
																''
															)}
														</td>
														<td>
															<a
																className="btn btn-outline-info"
																data-bs-toggle="collapse"
																href={`#collapseExample${data.id}`}
																role="button"
																aria-expanded="false"
																aria-controls={`collapseExample${data.id}`}
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	width="18"
																	height="18"
																	fill="currentColor"
																	className="bi bi-chevron-double-down"
																	viewBox="0 0 16 16"
																>
																	<path
																		fillRule="evenodd"
																		d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																	/>
																	<path
																		fillRule="evenodd"
																		d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																	/>
																</svg>
															</a>
														</td>
													</tr>
													<tr className={`collapse ${collapseOpenClose ? 'show' : ''}`} id={`collapseExample${data.id}`}>
														<td colSpan={3} style={{ width: 'auto', paddingLeft: '15px' }}>
															{data.desc ? parse(data.desc) : ''}
														</td>
														<td></td>
													</tr>
												</React.Fragment>
											)
										})}
									</tbody>
								</table>
								{/* Invoice info */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
